import React from 'react';
import { Users } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { RiyalIcon } from './icons';
import { useAmountVisibility, maskAmount } from './AmountVisibilityContext';

type Props = {
  stats: {
    totalPilgrims: number;
    regularPilgrims: number;
    notOwnerPilgrims: number;
    totalAmount: number;
    bonusAmount: number;
  };
};

export const OrganizerStats = ({ stats }: Props) => {
  const { translations } = useLanguage();
  const { showAmounts } = useAmountVisibility();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-6">
      <div className="bg-green-50 p-4 rounded-lg">
        <div className="flex items-center gap-2 mb-2">
          <span className="font-medium text-green-700">
            {translations?.organizerFinance?.financialStats?.totalAmount || 'Total Amount'}
          </span>
        </div>
        <div className="flex items-center text-2xl font-bold text-green-600">
          {maskAmount(stats.totalAmount, showAmounts)}  <RiyalIcon className="ml-1" size={20} />
        </div>
        {stats.bonusAmount > 0 && (
          <div className="text-sm text-green-600 mt-1">
            {translations?.organizerFinance?.financialStats?.includesBonus?.replace('{{bonusAmount}}', maskAmount(stats.bonusAmount, showAmounts)) || `Includes ${maskAmount(stats.bonusAmount, showAmounts)} SAR bonus`}
          </div>
        )}
      </div>

      <div className="bg-blue-50 p-4 rounded-lg">
        <div className="flex items-center gap-2 mb-2">
          <Users className="text-blue-500" size={20} />
          <span className="font-medium text-blue-700">
            {translations?.organizerFinance?.financialStats?.pilgrimsDistribution || 'Pilgrims Distribution'}
          </span>
        </div>
        <div className="flex items-center gap-4">
          <div>
            <div className="text-sm text-blue-600">
              {translations?.organizerFinance?.regularPilgrims || 'Regular'}
            </div>
            <div className="text-xl font-bold text-blue-600">
              {stats.regularPilgrims}
            </div>
          </div>
          <div>
            <div className="text-sm text-blue-600">
              {translations?.organizerFinance?.notOwnerPilgrims || 'Not Owner'}
            </div>
            <div className="text-xl font-bold text-blue-600">
              {stats.notOwnerPilgrims}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-yellow-50 p-4 rounded-lg">
        <div className="flex items-center gap-2 mb-2">
          <span className="font-medium text-yellow-700">
            {translations?.organizerFinance?.financialStats?.bonus || 'Bonus'}
          </span>
        </div>
        <div className="flex items-center text-2xl font-bold text-yellow-600">
          {maskAmount(stats.bonusAmount, showAmounts)} <RiyalIcon className="ml-1" size={20} />
        </div>
        <div className="text-sm text-yellow-600 mt-1">
          {stats.bonusAmount > 0 
            ? (translations?.organizerFinance?.financialStats?.bonusApplied || 'Bonus applied for exceeding 500 pilgrims')
            : (translations?.organizerFinance?.financialStats?.bonusNotApplied || 'No bonus (under 500 pilgrims)')}
        </div>
      </div>
    </div>
  );
};